import(/* webpackMode: "eager" */ "/app/src/app/welcome/template.tsx");
